/**
 * Utilitário para manipulação de class names
 */

/**
 * Combina class names filtrando valores falsy
 * @param values - Array de class names (strings, undefined, false, null)
 * @returns String com classes concatenadas
 * 
 * @example
 * mergeClassNames('btn', isActive && 'active', undefined, 'primary')
 * // Retorna: "btn active primary"
 */
export const mergeClassNames = (
  ...values: Array<string | undefined | false | null>
): string => {
  return values.filter(Boolean).join(" ");
};
